import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, Grid } from '@mui/material';
import Localization from 'l18n/l18n';
import * as React from 'react';

const CalendarTopbar = ({setPreviousWeekDate,setNextWeekDate})=>{

    return (
        <Grid  container  item  lg={4}  md={8}  xs={12} sx={{ textAlign: 'right' }} >

        <Grid item xs={4}>
          <Button
            variant="text"
            startIcon={<ArrowForwardIosIcon />}
            size="small"
            onClick={setPreviousWeekDate}
            style={{color:'#000'}}
          >
            {Localization.translate['previous']}
          </Button>
        </Grid>
        <Grid item xs={4} sx={{ textAlign: 'right' , fontsize:'21rem',fontWeight:'bold' }}>
          {Localization.translate['current_week']}
        </Grid>
        <Grid item xs={4}>
        <Button style={{color:'#000'}} variant="text" endIcon={<ArrowBackIosIcon />} size="small"  color="primary" onClick={setNextWeekDate} >
          {Localization.translate['Next']}
        </Button>
        </Grid>
      </Grid>
    );
};

export default CalendarTopbar;